<template>
  <div class="detail">
    <headd :mobile_title="mobile_title"></headd>
    <div class="order_detail_box container">
      <div class="box_head">
        <div class="head_title">订单详情</div>
        <div class="head_icon">
          <img src="../../../static/order/icon_4.png" />
        </div>
      </div>
      <div class="item_head">
        <div class="head_info">
          <div class="info_icon">
            <img src="../../../static/order/icon_type_1.png" />
          </div>
          <div class="info_type">{{ info.ctitle }}</div>
        </div>
      </div>
      <div class="info">
        <div class="name">{{ info.title }}</div>
        <div class="option" v-if="info.option || info.otheroption">
          <div class="title">选项:</div>
          <div class="content">
            <div v-if="info.option">{{ info.option }}</div>
            <div v-if="info.otheroption">{{ info.otheroption }}</div>
          </div>
        </div>
        <div class="option" v-if="couponcount > 0">
          <div class="title">优惠券:</div>
          <div
            class="content"
            style="justify-content: space-between;display: flex;flex-direction: row;"
          >
            {{ couponcount > 0 ? "有" + couponcount + "张可用" : "暂无可用" }}
            <span @click="fnClick" style="color:#0066CC;margin-left:0.2rem"
              >请选择></span
            >
          </div>
        </div>
        <div class="option" v-if="orderinfo.coupon_discount > 0">
          <div class="title">优惠金额:</div>
          <div class="content">
            <div>
              <span class="red">{{ orderinfo.coupon_discount }}</span
              >元
            </div>
          </div>
        </div>
        <div class="option" v-if="youhuiquan != ''">
          <div class="title">已选择：</div>
          <div class="content">{{ youhuiquan }}</div>
        </div>
        <div class="option">
          <div class="title">订单金额:</div>
          <div class="content">
            <div>{{ info.price }}元</div>
          </div>
        </div>
        <div class="price">
          <div class="title">应付款:</div>
          <div class="content">
            <span class="span" style="margin-left:0">{{ sjprice }}</span
            >元
          </div>
        </div>
        <div class="customertel">
          <div class="title">客户电话:</div>
          <div class="content">
            <div>
              <input
                type="text"
                v-model="customertel"
                placeholder="请输入手机号"
              />
            </div>
          </div>
        </div>
        <div class="customerTips">* 请仔细确认客户手机号<br>* 若手机号未注册将自动注册为新用户<br>* 点击下单自动支付成功并分配订单，请谨慎处理！！！</div>
      </div>
      <div class="info">
        <!-- <div style="padding: 0rem 0rem 0.3rem 0;flex-direction: column;">
          <div class="name">请选择支付方式</div>
          <div class="pay_type">
            <div
              class="type_item"
              v-for="(item, index) in items"
              :key="item.value"
            >
              <div class="type_name">
                <div class="type_icon">
                  <img
                    :src="'../../../static/order/pay_' + item.value + '.png'"
                  />
                </div>
                {{ item.name }}
                <div v-if="item.name == '余额'">({{ info.balance }}元)</div>
              </div>
              <div>
                <input
                  class="radio"
                  type="radio"
                  id="type"
                  :value="item.value"
                  :checked="index === current"
                  v-model="paytype"
                />
              </div>
            </div>
          </div>
        </div> -->
        <div class="btn_list">
          <div class="bbtn btngm" @click="payorder">代客下单</div>
        </div>
      </div>
    </div>
    <el-dialog title="优惠券" :visible.sync="dialogFormVisible" width="6rem">
      <div class="coupon">
        <div class="coupon_list">
          <div
            class="coupon_item"
            v-for="(item, index) in info.coupon"
            :data-id="item.id"
          >
            <div class="price">
              <span class="text">￥</span>{{ item.couponDiscount }}
            </div>
            <div class="title">
              {{ item.couponTitle }}
              <input
                class="radio"
                type="radio"
                :value="item.couponDiscount"
                :checked="current_2 == index"
                @click="radioChange_2(index)"
              />
            </div>
          </div>
        </div>
        <div class="coupon_btn">
          <div class="btnc" @click="selectCou">确定</div>
        </div>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
import { getpayorder, getorderpayment } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      mobile_title: "支付结算",
      dialogFormVisible: false,
      dialogFormVisible_2: false,
      items: [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ],
      type: ["alipay", "wxpcpay", "balancepay"],
      current: 0,
      current_2: -1,
      info: {},
      sjprice: 0,
      couponcount: 0,
      youhuiquan: "",
      paytype: "1",
      mobile: false,
      customertel: ""
    };
  },
  components: {
    //cmdCellItem,
    //uniPopup
    headd,
    foot
  },
  async mounted() {
    this.orderinfo();
    if (this.isWeiXin()) {
      this.items = [
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ];
      this.paytype = "2";
      this.mobile = true;
    } else {
      this.items = [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ];
      this.paytype = "1";
      this.mobile = false;
    }
  },
  methods: {
    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //alert(JSON.stringify(ua));
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      console.log(123);
      this.dialogFormVisible_2 = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    qr_btn() {
      this.$router.push({
        name: "order_list"
      });
    },
    fnClick() {
      if (this.couponcount > 0) {
        this.dialogFormVisible = true;
      }
    },
    radioChange: function(evt) {
      console.log(evt);
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value === evt.target.value) {
          this.current = i;
          break;
        }
      }
    },
    radioChange_2(index) {
      //console.log(evt)
      var _self = this;
      if (_self.current_2 == index) {
        // 如果已经选中，则取消选中
        _self.current_2 = -1;
        _self.youhuiquan = "";
        _self.sjprice = _self.info.price.toFixed(2);
      } else {
        // 否则进行选中赋值
        _self.current_2 = index;
        _self.youhuiquan = _self.info.coupon[index].couponTitle;
        _self.sjprice = (
          _self.info.price - _self.info.coupon[index].couponDiscount
        ).toFixed(2);
      }
    },

    selectCou() {
      console.log(this.current_2);

      this.dialogFormVisible = false;
    },
    async orderinfo() {
      var _self = this;
      var data = _self.data;
      var parm = this.$route.query;
      var data_1 = {
        uid: parm.uid,
        comboid: parm.comboid,
        option: parm.option,
        otheroption: parm.otheroption
      };
      console.log(JSON.stringify(parm));
      const res = await getpayorder(data_1);
      //console.log(res.data);
      _self.info = res.data;
      _self.sjprice = res.data.price;
      _self.couponcount = res.data.coupon.length;
    },
    payorder() {
      var _self = this;
      var couponid = "";
      var query = this.$route.query;
      console.log(_self.type[_self.paytype - 1]);
      if (_self.current_2 != -1) {
        couponid = _self.info.coupon[_self.current_2].id;
      }

      var phone_reg = /^1[3456789]\d{9}$/;

      if (_self.customertel == "") {
        this.$toast("请输入手机号码");

        return false;
      } else {
        if (!phone_reg.test(_self.customertel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }

      //var data = JSON.parse(_self.data);
      var info = _self.info;
      var couponid = "";
      if (_self.current_2 != -1) {
        couponid = _self.info.coupon[_self.current_2].id;
      }
      var parm = {
        uid: localStorage.getItem("userId"),
        couponid: couponid,
        comboid: query.comboid,
        option: query.option,
        otheroption: query.otheroption,
        pay_type: "cashpay",
        customertel: _self.customertel
      };
      console.log(parm);
      //return false;
      _self.pay_y(parm);
    },

    async pay_weixin_mobile(parm) {
      var _self = this;
      const res = await getorderpayment(parm);
      var data = JSON.parse(res.data.payStr);
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        _self.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      var _self = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "" + data.appId,
          timeStamp: "" + data.timeStamp,
          nonceStr: "" + data.nonceStr,
          package: "" + data.package,
          signType: "" + data.signType,
          paySign: "" + data.paySign
        },
        function(res) {
          console.log(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.push({
              path: "order_list"
            });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },

    async pay_weixin(parm) {
      var _self = this;
      const res = await getorderpayment(parm);
      console.log(JSON.parse(res.data.payStr).code_url);
      _self.dialogFormVisible_2 = true;
      _self.$nextTick(function() {
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.parse(res.data.payStr).code_url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },

    async pay_y(parm) {
      //console.log(parm)
      const res = await getorderpayment(parm);
      //console.log(res);
      var orderid = res.data.orderid;
      if (res.status == 1) {
        this.$toast({
          message: "支付成功",
          type: "success"
        });
        this.$router.push({
          path: "pay",
          query: {
            pay_status: "s",
            orderid: orderid
          }
        });
      } else {
        this.$toast(res.msg);
        this.$router.push({
          path: "pay",
          query: {
            pay_status: "f",
            orderid: orderid
          }
        });
      }
    },
    async pay(parm) {
      var _self = this;
      console.log(parm);
      const res = await this.$myRuquest({
        url: "/orderpayment",
        data: parm,
        method: "POST"
      });
      console.log(res);
      var orderid = res.data.data.orderid;
      if (res.data.status == 1) {
        console.log(_self.type[_self.current]);
        if (_self.type[_self.current] == "alipay") {
          uni.requestPayment({
            provider: "alipay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: res.data.data.payStr, //后台返回的支付宝订单数据
            success(res) {
              //console.log('success:' + JSON.stringify(res));
              uni.navigateTo({
                url: "../pay/pay?pay_status=t&orderid=" + orderid
              });
            },
            fail(err) {
              //console.log('fail:' + JSON.stringify(err));
              uni.navigateTo({
                url: "../pay/pay?pay_status=f&orderid=" + orderid
              });
            }
          });
        } else if (_self.type[_self.current] == "wxpay") {
          uni.requestPayment({
            provider: "wxpay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: JSON.parse(res.data.data.payStr), //后台返回的支付宝订单数据
            success(res) {
              //console.log('success:' + JSON.stringify(res));
              uni.navigateTo({
                url: "../pay/pay?pay_status=t&orderid=" + orderid
              });
            },
            fail(err) {
              //console.log('fail:' + JSON.stringify(err));
              uni.navigateTo({
                url: "../pay/pay?pay_status=f&orderid=" + orderid
              });
            }
          });
        }
      }
    }
  },
  onLoad(options) {
    if (options.data) {
      //console.log(options.data)
      this.data = options.data;
      this.orderinfo();
    }
    this.$logindex();
  }
};
</script>

<style scoped lang="less">
.container {
  padding: 0;
}
.order_detail_box {
  width: 8rem;
  margin: 0.3rem auto;
  border: 0.01rem solid #c4c4cc;
  height: auto;
  padding: 0;
  background: #ffffff;
  border-radius: 0.2rem;
  flex-direction: column;
  overflow: hidden;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    border: 0;
    border-radius: 0;
  }

  .box_head {
    width: 100%;
    height: auto;
    padding: 0.2rem 0.3rem;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.5);
    position: relative;
    display: flex;
    @media (max-width: 991px) {
      padding: 0.2rem 0rem;
    }
    .head_title {
      font-size: 0.2rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.3rem;
      position: relative;
      padding-left: 0.1rem;
      @media (max-width: 991px) {
        font-size: 0.3rem;
        line-height: 0.4rem;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0.05rem;
        height: 0.26rem;
        background: url(../../../static/order/icon_3.png) no-repeat;
        background-size: 0.05rem 0.26rem;
        @media (max-width: 991px) {
          top: 0.08rem;
          width: 0.04rem;
          height: 0.26rem;
        }
      }
    }

    .head_icon {
      width: 0.2rem;
      height: 0.11rem;
      @media (max-width: 991px) {
        width: 0.3rem;
        height: 0.16rem;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .head_status {
      position: absolute;
      top: 0.27rem;
      right: 0.6rem;
      font-size: 0.26rem;
      line-height: 0.26rem;
      color: #1395ff;
    }
  }
  .item_head {
    width: 100%;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.22rem 0.3rem;
    height: auto;
    @media (max-width: 991px) {
      padding: 0.22rem 0rem;
    }

    .head_info {
      display: flex;
      align-items: center;
      .info_icon {
        width: 0.28rem;
        height: 0.26rem;
        margin-right: 0.11rem;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .info_type {
        font-size: 0.24rem;
        color: #1b1c33;
        line-height: 0.3rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
  }

  .info {
    flex-direction: column;
    width: 100%;
    padding: 0.3rem 0.3rem;
    overflow: hidden;
    //border-bottom: 1rpx solid rgba(196, 196, 204, 0.5);
    @media (max-width: 991px) {
      padding: 0.3rem 0rem;
    }
    .name {
      font-size: 0.24rem;
      font-weight: bolder;
      color: #1b1c33;
      margin-bottom: 0.2rem;
      justify-content: space-between;
      align-items: center;
      height: auto;
      display: flex;
      @media (max-width: 991px) {
        font-size: 0.3rem;
      }

      .head_status {
        margin-top: 0.02rem;
        width: 0.96rem;
        height: 0.38rem !important;
        border-radius: 0.2rem !important;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.38rem !important;
        align-items: center;
        justify-content: center;
        font-weight: normal;
      }

      .head_status.status1 {
        border: 1px solid #1395ff;
        color: #1395ff;
      }

      .head_status.status2 {
        border: 1px solid #ff545a;
        color: #ff545a;
      }

      .head_status.status3 {
        border: 1px solid #8d8e99;
        color: #8d8e99;
      }
    }

    .option {
      flex-direction: row;
      margin-bottom: 0.2rem;
      display: flex;

      .title {
        font-size: 0.16rem;
        color: #8d8e99;
        line-height: 0.25rem;
        width: 0.96rem;
        @media (max-width: 991px) {
          width: 1.26rem;
          font-size: 0.28rem;
          line-height: 0.3rem;
        }
      }

      .content {
        flex-direction: column;
        font-size: 0.16rem;
        color: #444649;
        line-height: 0.25rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.3rem;
        }

        div {
          margin-bottom: 0.15rem;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 0.32rem;
            font-weight: 600;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 0.21rem;
      font-size: 0.16rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.25rem;
      display: flex;

      .span {
        margin-left: 0.1rem;
        color: #ff545a;
      }
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.3rem;
      }
      .title {
        width: 0.96rem;
        @media (max-width: 991px) {
          width: 1.26rem;
        }
      }
    }

    .customertel {
      margin-top: 0.21rem;
      font-size: 0.16rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.25rem;
      display: flex;
      align-items: center;

      .span {
        margin-left: 0.1rem;
        color: #ff545a;
      }
      @media (max-width: 991px) {
        font-size: 0.28rem;
        line-height: 0.3rem;
      }
      .title {
        width: 0.96rem;
        @media (max-width: 991px) {
          width: 1.26rem;
        }
      }
      input {
        font-weight: normal;
      }
    }
    .customerTips{
       margin-top: 0.21rem;
       font-size: 0.12rem;
       color:red;
    }

    .pay_type {
      width: 100%;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;

        .type_name {
          font-size: 0.16rem;
          color: #1b1c33;
          display: flex;
          align-items: center;
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }

          .type_icon {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.1rem;
            display: flex;
            align-items: center;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .radio {
          width: 0.24rem;
          height: 0.24rem;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
      }
    }

    .btn_list {
      justify-content: space-around;
      display: flex;
      flex-wrap: wrap;

      .bbtn {
        width: 2.6rem;
        height: 0.7rem;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.7rem;
        justify-content: center;
        align-items: center;
        border-radius: 0.4rem;
        text-align: center;
        cursor: pointer;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }

      .bbtn.btnzx {
        background-color: #1395ff;
      }

      .bbtn.btngm {
        background-color: #f4556c;
      }
    }
  }

  .daiban {
    padding: 0rpx;
    flex-direction: column;

    .p {
      margin: 0.4rem 0.7rem;
      font-size: 0.2rem;
      color: #1b1c33;
    }

    .upload {
      justify-content: space-between;
      margin-bottom: 0.2rem;
      position: relative;

      .upload_name {
        font-size: 0.28rem;
        color: #1b1c33;
      }

      .upload_btn {
        width: 2.6rem;
        height: 0.44rem;
        border-radius: 0.22rem;
        border: 0.01rem solid #1395ff;
        font-size: 0.26rem;
        color: #1395ff;
        align-items: center;
        justify-content: center;

        .icon {
          width: 0.11rem;
          height: 0.14rem;
          margin-right: 0.1rem;
        }
      }
    }

    .upload_tip {
      font-size: 0.26rem;
      color: #1395ff;
      text-align: right;
      justify-content: flex-end;
    }

    .upload_save {
      margin: 0.6rem auto 0 auto;
      width: 5.9rem;
      height: 0.8rem;
      background: url(../../../static/order/btn_3.png) no-repeat;
      background-size: 5.9rem 0.8rem;
      font-size: 0.36rem;
      color: #ffffff;
      line-height: 0.8rem;
      justify-content: center;
      align-items: center;
    }

    .btn_list {
      justify-content: center;
      margin-bottom: 0.4rem;
      text-align: center;

      .btn {
        text-align: center;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #1395ff;
        line-height: 0.7rem;
        height: 0.7rem;
        border-radius: 0.35rem;
        border: 0.02rem solid #1395ff;
        padding: 0rem 0.31rem;
        margin: 0 0.09rem;
      }
    }

    .box {
      margin: 0.4rem 0.7rem;

      height: auto;
      flex-direction: column;

      .box_title {
        font-size: 0.38rem;
        line-height: 0.38rem;
        margin-bottom: 0.4rem;
        align-items: center;

        .title_icon {
          width: 0.32rem;
          height: 0.33rem;
          margin-right: 0.1rem;
        }
      }

      .dbox_cell {
        align-items: center;
        justify-content: flex-start;
        margin: 0 0.4rem 0.4rem 0rem;
        display: flex;

        .dbox_name {
          width: 1.25rem;
          height: 0.25rem;
          font-size: 0.18rem;
          color: #5e5e66;
          line-height: 0.25rem;
          text-align: justify;
          display: inline-block;
          // text-align-last: justify;
        }

        .img_list {
          flex-wrap: wrap;
          width: 5.23rem;
          padding: 0.2rem;
          background: rgba(196, 196, 204, 0.1);
          border-radius: 0.12rem;
          display: flex;

          .img_item {
            flex-direction: column;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
            width: 1rem;
            height: 1rem;
            border: 0.01rem solid #979797;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            align-items: center;
            border-radius: 0.12rem;
            background-color: #fff;
            justify-content: center;
            display: flex;
            position: relative;

            .item_icon {
              width: 0.3rem;
              height: 0.29rem;
            }

            .img_url {
              width: 1.6rem;
              height: 1.6rem;
              margin-bottom: 0.2rem;
              opacity: 0;
            }

            .img_name {
              text-align: center;
              font-size: 0.26rem;
              line-height: 0.26rem;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #1b1c33;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .delete {
              position: absolute;
              top: -0.15rem;
              right: -0.15rem;
              width: 0.4rem;
              height: 0.4rem;
              z-index: 2;
            }
          }
        }

        .dbox_input {
          flex: 1;
          .input {
            width: 100%;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            font-size: 0.18rem;
            line-height: 0.25rem;
            padding: 0.17rem;
            color: #333;
          }

          .textarea {
            width: 100%;
            font-size: 0.18rem;
            color: #333;
            line-height: 0.25rem;
            padding: 0.17rem;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            resize: none;
          }

          .select {
            width: 100%;
            padding: 0.17rem;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            font-size: 0.18rem;
            align-items: center;
            justify-content: flex-start;
          }
        }

        .dbox_upload {
          width: 2.23rem;
          padding: 0.2rem;
          height: 1.23rem;
          background: rgba(196, 196, 204, 0.1);
          border-radius: 0rem;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          position: relative;
          background-size: cover;
          background-position: center;
          text-align: center;
          display: flex;

          .upload {
            width: 1rem;
            height: 0.83rem;
            margin-bottom: 0.23rem;

            img {
              width: 0.5rem;
              height: 0.42rem;
            }
          }

          .upload_text {
            height: 0.25rem;
            font-size: 0.16rem;
            color: #1b1c33;
            line-height: 0.25rem;
          }

          .upload_tip {
            height: 0.42rem;
            font-size: 0.3rem;
            color: #8d8e99;
            line-height: 0.42rem;
          }

          .delete {
            position: absolute;
            top: -0.15rem;
            right: -0.15rem;
            width: 0.4rem;
            height: 0.4rem;
            z-index: 2;
          }
        }
      }

      .btn_save {
        margin: 0.5rem auto 0.5rem auto;
        width: 2.94rem;
        height: 0.7rem;
        line-height: 0.7rem;
        background: #1395ff;
        border-radius: 0.35rem;
        font-size: 0.24rem;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .rate {
    margin: 0.3rem 0.3rem;
    flex-direction: column;

    .rate_list {
      //align-items: center;
      position: relative;
      min-height: 1.4rem;
      display: flex;

      .rate_line {
        width: 0.4rem;
        text-align: center;

        .i {
          margin-top: 0.2rem;
          margin-left: 0rem;
          border-radius: 50%;
          width: 0.2rem;
          height: 0.2rem;
          background: #1395ff;
          z-index: 1;
        }
      }

      .rate_msg {
        margin-left: 0rem;
        margin-bottom: 0.2rem;
        height: auto;
        border-radius: 0.12rem;
        border: 0.01rem solid rgba(19, 149, 255, 0.5);
        flex-direction: column;
        flex: 1;

        .msg_head {
          padding: 0.1rem 0.2rem;
          font-size: 0.18rem;
          line-height: 0.25rem;
          color: #1395ff;
          border-bottom: 0.01rem solid rgba(19, 149, 255, 0.2);
          align-items: center;
          justify-content: space-between;
          display: flex;

          .time {
            font-size: 0.14rem;
            line-height: 0.26rem;
            color: #8d8e99;
          }
        }

        .msg_con {
          padding: 0.2rem;
          font-size: 0.2rem;
          color: #1b1c33;
          flex-direction: column;

          .con_cell {
            font-size: 0.16rem;
            line-height: 0.25rem;
            color: #1b1c33;
            margin-bottom: 0.2rem;

            &:last-child {
              margin-bottom: 0;
            }
          }

          .con_cell.link {
            color: #1395ff;
          }

          .con_op {
            margin-top: 0.2rem;
          }

          .img_list {
            flex-wrap: wrap;
            margin-bottom: 0.2rem;
            display: flex;

            .img_item {
              flex-direction: column;
              margin-right: 0.2rem;
              margin-bottom: 0.2rem;
              width: 1.2rem;
              //   height: 1.2rem;
              overflow: hidden;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 0rpx;
              /deep/.el-image__inner {
                width: 1.2rem;
                // height: 1.2rem;
                /* height: 1rem; */
              }

              .img_url {
                width: 1.2rem;
                height: 1.2rem;
                margin-bottom: 0.2rem;
                opacity: 0;
              }

              .img_name {
                text-align: center;
                font-size: 0.2rem;
                line-height: 0.26rem;
                color: #1b1c33;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }

          .file_list {
            flex-wrap: wrap;
            font-size: 0.16rem;
            display: flex;
            .img_item {
              display: flex;
            }

            .file_name {
              margin-right: 0.1rem;
            }

            .file_view {
              cursor: pointer;
              color: #1395ff;
              text-decoration: underline;
            }
          }
        }
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0.09rem;
        bottom: 0;
        width: 0.02rem;
        background: rgba(19, 149, 255, 1);
      }

      &:last-child {
        .rate_msg {
          margin-bottom: 0rpx;
        }
      }
    }
  }
}
.pay_c {
  margin: 0 auto 0.6rem;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: left;
  border-top: 0.02rem solid #f5f5f5;
}
.pay {
  margin: 0.1rem auto;
  border: 0.01rem solid #c4c4cc;
  height: auto;
  padding: 0;
  background: #ffffff;
  border-radius: 0.12rem;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;

  .order_head {
    width: 100%;
    padding: 0.2rem 0.7rem;
    font-size: 0.3rem;
    font-weight: bolder;
    color: #1b1c33;
    line-height: 0.36rem;
    letter-spacing: 0.01rem;
    position: relative;
    text-align: left;

    &::before {
      content: "";
      position: absolute;
      top: 0.25rem;
      left: 0.7rem;
      width: 0.05rem;
      height: 0.26rem;
      background: #1395ff;
      border-radius: 0.02rem;
    }
  }

  .item {
    width: 100%;
    height: auto;
    margin-bottom: 0;
    padding: 0 0 0.3rem 0;
    flex-direction: column;
    position: relative;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);

    .item_head {
      border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: ~"calc(100% - 0.64rem)";
      padding: 0.22rem 0.32rem;
      height: 0.26rem;

      .head_info {
        display: flex;
        .info_icon {
          width: 0.28rem;
          height: 0.26rem;
          margin-right: 0.11rem;

          image {
            width: 100%;
            height: 100%;
          }
        }

        .info_type {
          font-size: 0.3rem;
          color: #1b1c33;
          line-height: 0.3rem;
        }
      }

      .head_status {
        width: 1.12rem;
        height: 0.42rem;
        border-radius: 0.23rem;
        font-size: 0.26rem;
        text-align: center;
        line-height: 0.42rem;
        align-items: center;
        justify-content: center;
      }

      .head_status.status1 {
        border: 1rpx solid #1395ff;
        color: #1395ff;
      }

      .head_status.status2 {
        border: 1rpx solid #ff545a;
        color: #ff545a;
      }

      .head_status.status3 {
        border: 1rpx solid #8d8e99;
        color: #8d8e99;
      }
    }

    .info {
      flex-direction: column;
      width: ~"calc(100% - 0.64rem)";
      padding: 0 0.32rem;

      .name {
        font-size: 0.3rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.42rem;
        letter-spacing: 0.01rem;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;
      }

      .option {
        flex-direction: row;
        margin-bottom: 0.2rem;
        display: flex;

        .title {
          font-size: 0.28rem;
          color: #8d8e99;
          line-height: 0.37rem;
          width: 1.08rem;
        }

        .content {
          flex-direction: column;
          font-size: 0.28rem;
          color: #444649;
          line-height: 0.37rem;

          view {
            margin-bottom: 0.15rem;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      .price {
        margin-top: 0.21rem;
        font-size: 0.3rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.42rem;
        letter-spacing: 0.01rem;
        .title {
          width: 0.96rem;
        }

        .span {
          color: #ff545a;
        }
      }
    }

    .btn_detail {
      position: absolute;
      bottom: 0.3rem;
      right: 0.2rem;
      width: 1.4rem;
      height: 0.44rem;
      background: #1395ff;
      border-radius: 0.22rem;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      color: #ffffff;
      line-height: 0.44rem;
    }
  }

  .info {
    flex-direction: column;
    width: ~"calc(100% - 0.64rem)";
    padding: 0.2rem 0.32rem;
    text-align: left;

    .name {
      font-size: 0.3rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.42rem;
      margin-bottom: 0.2rem;
      margin-top: 0.2rem;
    }

    .option {
      flex-direction: row;
      margin-bottom: 0.2rem;

      .title {
        font-size: 0.26rem;
        color: #1b1c33;
        line-height: 0.37rem;
        width: 1.3rem;
      }

      .content {
        width: 5rem;
        flex-direction: column;
        font-size: 0.26rem;
        color: #444649;
        line-height: 0.37rem;

        view {
          margin-bottom: 0.15rem;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 0.3rem;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 0.21rem;
      font-size: 0.3rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.42rem;
      letter-spacing: 0.01rem;

      .span {
        color: #ff545a;
      }
    }

    .pay_type {
      width: 100%;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;

        .type_name {
          font-size: 0.3rem;
          color: #1b1c33;

          .type_icon {
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.2rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .btn_list {
      width: 100%;
      justify-content: space-between;
      margin-top: 0.2rem;

      .btn {
        width: 3.09rem;
        height: 0.8rem;
        font-size: 0.36rem;
        color: #ffffff;
        line-height: 0.8rem;
        letter-spacing: 0.02rem;
        text-align: center;
        justify-content: center;
        align-items: center;
      }

      .btn.kefu {
        //background: url(../../static/order/btn_1.png) no-repeat;
        //background-size: 309rpx 80rpx;
      }

      .btn.buy {
        //background: url(../../static/order/btn_2.png) no-repeat;
        //background-size: 309rpx 80rpx;
      }
    }
  }

  .btn_pay {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.96rem;
    background: #f4556c;
    line-height: 0.96rem;
    text-align: center;
    font-size: 0.36rem;
    color: #ffffff;
    justify-content: center;
    align-items: center;
  }

  .cell {
    height: auto;
    padding: 0.2rem 0.32rem;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);
    font-size: 0.28rem;
    display: flex;

    .cell_title {
      color: #5e5e66;
    }

    .cell_input {
      color: #1b1c33;
    }

    .color_type {
      color: #ff545a;
      font-weight: bolder;
    }
  }

  .font_30 {
    font-size: 0.3rem;
  }
}

.coupon {
  width: 100%;
  height: auto;
  padding: 0 0 0 0;
  border-radius: 0.24rem 0.24rem 0 0;
  background-color: #fff;
  flex-direction: column;

  .coupon_title {
    font-size: 0.3rem;
    margin: 0.2rem;
  }

  .coupon_list {
    flex-direction: column;
    background: #f2f2f2;
    padding: 0.3rem 0;

    .coupon_item {
      margin: 0.2rem;

      display: flex;
      align-items: center;

      .price {
        border-radius: 0.2rem 0 0 0.2rem;
        width: 1rem;
        height: 0.8rem;
        background-color: #0062cc;
        color: #fff;
        align-items: center;
        justify-content: center;
        font-size: 0.26rem;
        display: flex;
        .text {
          font-size: 0.2rem;
        }
        @media (max-width: 991px) {
          width: 1.5rem;
          font-size: 0.32rem;
        }
      }

      .title {
        font-size: 0.2rem;
        width: 3.7rem;
        background-color: #ffffff;
        padding: 0 0.2rem;
        height: 0.8rem;
        line-height: 0.8rem;
        align-items: center;
        justify-content: space-between;
        border-radius: 0rpx 0.2rem 0.2rem 0rpx;
        display: flex;
        .radio {
          width: 0.2rem;
          height: 0.2rem;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
  }

  .coupon_btn {
    width: 100%;
    height: 0.84rem;
    padding: 0.1rem 0;
    background: #ffffff;
    align-items: center;
    justify-content: center;

    .btnc {
      margin: auto;
      width: 2.96rem;
      height: 0.7rem;
      background-color: #0062cc;
      line-height: 0.7rem;
      color: #fff;
      font-size: 0.24rem;
      align-items: center;
      justify-content: center;
      border-radius: 0.35rem;
      display: flex;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }
}
.btn_list {
  justify-content: space-around;
  display: flex;
  flex-wrap: wrap;

  .bbtn {
    width: 3.7rem;
    height: 0.7rem;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    text-align: center;
  }

  .bbtn.btnzx {
    background-color: #1395ff;
  }

  .bbtn.btngm {
    background-color: #f4556c;
  }
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.26rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
  }
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.26rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/order/order_pay.vue